// Nuxt server init module

const actions = {
  async nuxtServerInit (context, req) {
    await context.dispatch('getStores')

    // Resolve seoName only against known store nicknames. Echoing the raw
    // path back into <title>/<meta description> would let attackers poison
    // search results by sharing crafted URLs (HTML is escaped, so it's not
    // XSS — purely an SEO-poisoning surface).
    let seoName = 'Britain'
    if (req.route.name === 'all' && req.route.params.pathMatch) {
      const nickname = req.route.params.pathMatch.toLowerCase()
      const matchingStore = context.getters.stores.find(s => s.nickname && s.nickname.toLowerCase() === nickname)
      if (matchingStore) {
        seoName = matchingStore.city || matchingStore.name
      }
    }
    context.commit('setSeoName', seoName)

    try {
      const store = context.getters.stores.filter(store => store.nickname.toLowerCase() === req.route.path.replace('/', '').toLowerCase())
      const cookieData = this.$cookie ? JSON.parse(this.$cookie) : false
      if (cookieData) {
        if (store.length === 0) {
          await context.dispatch('setCurrentStore', (cookieData.data.currentStore ? { store_id: cookieData.data.currentStore.id } : null))
        } else {
          // we need to modify also the cookie
          await context.dispatch('setCurrentStore', ({ store_id: store[0].id }))
          cookieData.data.currentStore = context.getters.currentStore
          req.res.setHeader('Set-Cookie', [`${this.$cookieKey}=${JSON.stringify(cookieData)}`]) // setup the cookie from the serverside
        }
      } else if (store.length !== 0) {
        await context.dispatch('setCurrentStore', { store_id: store[0].id })
      } else {
        await context.dispatch('setCurrentStore', null)
      }
    } catch (e) {
      console.log('e', e)
    }
  }
}

export default {
  actions
}
